import { publisher } from './publisher';

const buildRecommendations = (recommendations = []) => {
  const reviews = recommendations.filter(recommendation => !!recommendation.comment);

  return reviews.map(review => ({
    reviewBody: review.comment,
    givenName: review.name ? review.name.split(' ')[0] : undefined
  }));
};

export const generateReview = recommendations => {
  return buildRecommendations(recommendations).map(i => {
    const { reviewBody, givenName } = i;
    return {
      '@type': 'Review',
      reviewBody,
      author: {
        '@type': 'Person',
        givenName
      },
      publisher
    };
  });
};
